import React from 'react';

const SvgSave = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      d="M3.6.3v3a.3.3 0 0 0 .3.3h4.2a.3.3 0 0 0 .3-.3v-3a.3.3 0 0 1 .3-.3h.652a.6.6 0 0 1 .424.176l2.048 2.048a.6.6 0 0 1 .176.424V11.4a.6.6 0 0 1-.6.6H.6a.6.6 0 0 1-.6-.6V.6A.6.6 0 0 1 .6 0h2.7a.3.3 0 0 1 .3.3zM6.3 0h.6a.3.3 0 0 1 .3.3v1.8a.3.3 0 0 1-.3.3h-.6a.3.3 0 0 1-.3-.3V.3a.3.3 0 0 1 .3-.3zM3.9 7.8a2.1 2.1 0 1 0 4.199 0 2.1 2.1 0 0 0-4.199 0z"
    />
  </svg>
);

export default SvgSave;
